/* Groups existing products for display; each color retains its own product URL. */
(() => {
  const categories = ['すべて', 'サッカーゴール', 'リバウンドネット', '防球ネット', 'ミニハードル', 'その他', '交換パーツ'];
  const normalize = value => value.normalize('NFKC').toLowerCase().trim();
  function metadata(row) {
    const saved = window.rfCatalogMetadata?.[row.dataset.handle];
    if (saved) return saved;
    const title = row.dataset.title, type = row.dataset.type;
    // New products stay visible. Unrecognized types fall into その他 until classified.
    const category = categories.includes(type) ? type : /専用|交換|パーツ/.test(title) ? '交換パーツ' : /ハードル/.test(title) ? 'ミニハードル' : /防球/.test(title) ? '防球ネット' : /リバウンド/.test(title) ? 'リバウンドネット' : /ゴール/.test(title) ? 'サッカーゴール' : 'その他';
    return {category, name: title, subtitle: '', family: category === 'サッカーゴール' ? (/折りたたみ/.test(title) ? 'folding' : 'portable') : '', group: '', color: '', partType: ''};
  }
  function releaseLoading(root) {
    clearTimeout(root.rfCatalogLoadingTimer);
    root.removeAttribute('data-loading');
    root.setAttribute('aria-busy', 'false');
  }
  async function initialize(root) {
    if (root.dataset.ready || root.dataset.all !== 'all') return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-rf-catalog-grid]');
    const controls = document.querySelector('[data-rf-categories]');
    const form = document.querySelector('[data-rf-catalog-search]');
    const rows = [...grid.querySelectorAll('[data-rf-source]')];
    // Read every collection page before applying cross-page categories/grouping.
    let next = root.querySelector('[data-rf-next-page]');
    const seen = new Set();
    try {
      while (next) {
        const url = new URL(next.getAttribute('href'), location.origin);
        if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid catalogue pagination');
        seen.add(url.href); url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Catalogue page unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = [...html.querySelectorAll('[data-rf-source]')];
        if (!batch.length) throw new Error('Catalogue page empty');
        rows.push(...batch); next = html.querySelector('[data-rf-next-page]');
      }
    } catch (error) {
      const status = root.querySelector('[data-rf-results]');
      status.textContent = '全商品の読み込みに失敗しました。再読み込みするか、次の商品を表示してください。';
      root.dataset.ready = '';
      releaseLoading(root);
      return; // Original product links and native next-page link remain usable.
    }
    const groups = new Map();
    const unique = new Set();
    rows.forEach(row => {
      if (unique.has(row.dataset.handle)) return;
      unique.add(row.dataset.handle);
      const meta = metadata(row), key = meta.group || row.dataset.handle;
      if (!groups.has(key)) groups.set(key, {key, meta, sources: []});
      groups.get(key).sources.push({row, meta});
    });
    const entries = [...groups.values()].sort((a,b) => (a.meta.position ?? Infinity)-(b.meta.position ?? Infinity)).map(entry => {
      const preferred = entry.sources.find(s => s.meta.color === (entry.meta.family === 'folding' ? 'ブラック' : 'イエロー')) || entry.sources[0];
      entry.card = preferred.row.cloneNode(true);
      entry.card.dataset.group = entry.key;
      entry.category = entry.meta.category;
      entry.search = normalize(entry.sources.map(s => [s.row.dataset.title, s.row.dataset.searchVariants, s.meta.name, s.meta.subtitle, s.meta.size, s.meta.category, s.meta.color].join(' ')).join(' '));
      entry.price = Math.min(...entry.sources.map(s => Number(s.row.dataset.price)));
      const swatches = entry.card.querySelector('[data-rf-swatches]');
      let gallery = [], imageIndex = 0, pointerStart, touchStart, suppressClickUntil = 0;
      const dots = document.createElement('div'); dots.className = 'rf-gallery-dots'; dots.setAttribute('role','img');
      entry.card.querySelector('.rf-card-gallery').append(dots);
      const showImage = index => {
        if (!gallery.length) return;
        imageIndex = (index + gallery.length) % gallery.length;
        const photo = entry.card.querySelector('.rf-catalog-photo img');
        if (photo) { photo.draggable=false;photo.removeAttribute('srcset'); photo.src = gallery[imageIndex].src; photo.alt = gallery[imageIndex].alt + ' 商品画像 ' + (imageIndex+1); }
        entry.card.querySelector('[data-rf-image-count]').textContent = (imageIndex+1) + ' / ' + gallery.length;
        dots.setAttribute('aria-label', '商品画像 ' + (imageIndex+1) + ' / ' + gallery.length);
        [...dots.children].forEach((dot,index)=>dot.classList.toggle('is-current',index===imageIndex));
      };
      const photoLink = entry.card.querySelector('.rf-card-gallery > a');
      entry.card.querySelector('[data-rf-image-prev]').addEventListener('click',()=>showImage(imageIndex-1));
      entry.card.querySelector('[data-rf-image-next]').addEventListener('click',()=>showImage(imageIndex+1));
      const finishSwipe = (dx,dy) => {
        if(Math.abs(dx)>=32&&Math.abs(dx)>Math.abs(dy)*1.3){
          suppressClickUntil=performance.now()+800;
          if(gallery.length>1)showImage(imageIndex+(dx<0?1:-1));
        }
      };
      // Touch input has its own path: scroll cancellation of pointer events cannot erase it.
      photoLink.addEventListener('touchstart',e=>{
        pointerStart=null;suppressClickUntil=0;
        if(e.touches.length!==1){touchStart=null;return;}
        const t=e.touches[0];touchStart={x:t.clientX,y:t.clientY,id:t.identifier,axis:null};
      },{passive:true});
      photoLink.addEventListener('touchmove',e=>{
        if(!touchStart||e.touches.length!==1){touchStart=null;return;}
        const t=[...e.touches].find(t=>t.identifier===touchStart.id);if(!t)return;
        const dx=t.clientX-touchStart.x,dy=t.clientY-touchStart.y;
        if(!touchStart.axis){
          if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)*1.3)touchStart.axis='x';
          else if(Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)*1.3)touchStart.axis='y';
        }
        if(touchStart.axis==='x'&&e.cancelable)e.preventDefault();
      },{passive:false});
      photoLink.addEventListener('touchend',e=>{
        if(!touchStart)return;
        const start=touchStart,t=[...e.changedTouches].find(t=>t.identifier===start.id);
        touchStart=null;if(t&&start.axis!=='y')finishSwipe(t.clientX-start.x,t.clientY-start.y);
      },{passive:true});
      photoLink.addEventListener('touchcancel',()=>{touchStart=null;},{passive:true});
      // Keep desktop pointer handling separate to avoid a double advance on touch browsers.
      photoLink.addEventListener('pointerdown',e=>{
        if(e.pointerType==='touch'||e.button>0)return;
        pointerStart={x:e.clientX,y:e.clientY,id:e.pointerId};suppressClickUntil=0;
      });
      photoLink.addEventListener('pointerup',e=>{
        if(e.pointerType==='touch'||!pointerStart||e.pointerId!==pointerStart.id)return;
        const start=pointerStart;pointerStart=null;finishSwipe(e.clientX-start.x,e.clientY-start.y);
      });
      photoLink.addEventListener('pointercancel',()=>{pointerStart=null;});
      photoLink.addEventListener('click',e=>{
        if(performance.now()<suppressClickUntil){e.preventDefault();e.stopPropagation();}
      },true);
      const select = source => {
        const card = entry.card, original = source.row, meta = source.meta;
        card.querySelectorAll('[data-rf-product-link]').forEach(a => a.href = original.querySelector('[data-rf-product-link]').getAttribute('href'));
        const photo = card.querySelector('.rf-catalog-photo img'), replacement = original.querySelector('.rf-catalog-photo img');
        if (photo && replacement) photo.replaceWith(replacement.cloneNode(true));
        const reviewHost = card.querySelector('[data-rf-card-reviews]');
        const reviewTemplate = original.querySelector('[data-rf-review-template]');
        if (reviewHost) {
          // Recreate the component with the selected product ID, never clone a previous rating.
          reviewHost.replaceChildren();
          if (reviewTemplate) reviewHost.append(reviewTemplate.content.cloneNode(true));
        }
        card.querySelector('[data-rf-name]').textContent = meta.name;
        card.querySelector('[data-rf-category]').textContent = meta.category;
        card.querySelector('[data-rf-description]').textContent = meta.group ? meta.size : meta.subtitle;
        const set = meta.count ? (meta.family === 'folding' && meta.count === 1 ? '単品' : meta.count + '個セット') : '';
        card.querySelector('[data-rf-color]').textContent = meta.color ? meta.color + ' / ' + set : '';
        card.querySelector('[data-rf-offer]').replaceWith(original.querySelector('[data-rf-offer]').cloneNode(true));
        card.querySelector('[data-rf-sold-out]')?.remove();
        if (original.querySelector('[data-rf-sold-out]')) card.append(original.querySelector('[data-rf-sold-out]').cloneNode(true));
        swatches.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === meta.color)));
        card.dataset.selectedHandle = original.dataset.handle;
        try { gallery = JSON.parse(original.querySelector('[data-rf-images]').textContent); } catch { gallery=[]; }
        imageIndex = 0;pointerStart=null;touchStart=null;suppressClickUntil=0;
        dots.replaceChildren(...gallery.map(()=>{const dot=document.createElement('span');dot.setAttribute('aria-hidden','true');return dot;}));
        dots.hidden=gallery.length<2;
        card.querySelector('[data-rf-gallery-controls]').hidden = gallery.length < 2;
        showImage(0);
      };
      if (entry.meta.group) {
        swatches.setAttribute('role', 'group'); swatches.setAttribute('aria-label', 'カラーを選択');
        entry.sources.forEach(source => {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.color = source.meta.color;
          button.setAttribute('aria-label', source.meta.color); button.title = source.meta.color;
          const dot = document.createElement('span'); dot.setAttribute('aria-hidden', 'true');
          dot.style.background = {'ブラック':'#162950','オレンジ':'#ef722f','ブルー':'#2678c9','イエロー':'#f8cf32'}[source.meta.color] || '#999';
          button.append(dot); button.addEventListener('click', () => select(source)); swatches.append(button);
        });
      }
      select(preferred); return entry;
    });
    const query = form.querySelector('input[name="q"]');
    const sort = root.querySelector('[data-rf-sort]');
    const part = root.querySelector('[data-part-type]');
    const partSize = root.querySelector('[data-part-size]');
    const sizeControl = root.querySelector('[data-part-size-control]');
    const sizeNote = root.querySelector('[data-part-size-note]');
    const more = root.querySelector('[data-rf-more]');
    let category = 'すべて', family = 'all', count = 24;
    function syncPartSizes(value = 'all') {
      const enabled = category === '交換パーツ' && ['ポータブルゴール','折りたたみゴール'].includes(part.value);
      sizeControl.hidden = !enabled;
      sizeNote.hidden = !enabled;
      const sizes = enabled ? [...new Set(entries.filter(e => e.meta.partType === part.value).flatMap(e => e.meta.partSizes || []).filter(s => s !== 'all'))] : [];
      partSize.replaceChildren(new Option('すべてのサイズ','all'), ...sizes.map(s => new Option(s,s)));
      partSize.value = sizes.includes(value) ? value : 'all';
    }
    function readURL() {
      const params = new URLSearchParams(location.search);
      category = categories.includes(params.get('rf_category')) ? params.get('rf_category') : 'すべて';
      family = ['folding','portable'].includes(params.get('rf_family')) ? params.get('rf_family') : 'all';
      query.value = params.get('rf_q') || '';
      part.value = params.get('rf_part') || 'all';
      if (!part.value) part.value = 'all';
      syncPartSizes(params.get('rf_part_size') || 'all');
      count = 24;
    }
    function updateURL() {
      const url = new URL(location.href);
      for (const [key,value] of [['rf_category',category === 'すべて' ? '' : category],['rf_family',family === 'all' ? '' : family],['rf_q',query.value],['rf_part',part.value === 'all' ? '' : part.value],['rf_part_size',partSize.value === 'all' ? '' : partSize.value]]) {
        if (value) url.searchParams.set(key,value); else url.searchParams.delete(key);
      }
      url.searchParams.delete('page'); history.replaceState(null, '', url);
    }
    function render() {
      const filtered = entries.filter(e => (category === 'すべて' || e.category === category) && (category !== 'サッカーゴール' || family === 'all' || e.meta.family === family) && (category !== '交換パーツ' || part.value === 'all' || e.meta.partType === part.value) && (category !== '交換パーツ' || partSize.value === 'all' || !e.meta.partSizes?.length || e.meta.partSizes.includes('all') || e.meta.partSizes.includes(partSize.value)) && e.search.includes(normalize(query.value)));
      if (sort.value !== 'featured') filtered.sort((a,b) => sort.value === 'low' ? a.price-b.price : b.price-a.price);
      else if (category === '交換パーツ' && part.value === '折りたたみゴール' && ['124×94cm','200×130cm'].includes(partSize.value)) {
        // Keep the size-specific parts in their existing order; shared pegs come last.
        const sharedPeg = '90-70cm124-94cm200-130cmgoal-peg';
        filtered.sort((a,b) => Number(a.key === sharedPeg) - Number(b.key === sharedPeg));
      }
      grid.replaceChildren(...filtered.slice(0,count).map(e => e.card));
      root.querySelector('[data-rf-results]').textContent = filtered.length + '件の商品';
      document.querySelector('.rf-catalog-number').textContent = entries.length + ' / COLLECTION';
      root.querySelector('[data-rf-empty]').hidden = filtered.length > 0;
      more.hidden = filtered.length <= count;
      more.textContent = 'さらに表示する（' + Math.min(24, filtered.length-count) + '件）';
      root.querySelector('[data-rf-goal-types]').hidden = category !== 'サッカーゴール';
      root.querySelector('[data-rf-parts]').hidden = category !== '交換パーツ';
      root.querySelector('[data-rf-wayfinding]').hidden = category !== 'すべて';
      controls.querySelectorAll('a').forEach(a => {
        const label = a.dataset.category;
        if (label === category) a.setAttribute('aria-current','page'); else a.removeAttribute('aria-current');
        a.querySelector('small').textContent = label === 'すべて' ? entries.length : entries.filter(e => e.category === label).length;
      });
      root.querySelectorAll('[data-family]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.family === family)));
    }
    controls.querySelectorAll('a').forEach(a => {
      a.dataset.category = a.textContent.trim().replace(/\s+\d+$/, '');
      a.querySelector('small')?.remove(); const badge = document.createElement('small'); a.append(' ',badge);
    });
    const navigate = event => {
      const a = event.target.closest('a');
      if (!a || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(a.href);
      if (url.pathname !== new URL(controls.querySelector('a').href).pathname) return;
      event.preventDefault();
      const params = url.searchParams;
      category = a.dataset.category || params.get('rf_category') || 'すべて';
      family = params.get('rf_family') || 'all'; part.value = 'all'; syncPartSizes(); count=24;
      updateURL(); render();
    };
    controls.addEventListener('click',navigate); root.querySelector('[data-rf-wayfinding]').addEventListener('click',navigate);
    form.addEventListener('submit',e => {e.preventDefault();count=24;updateURL();render();});
    query.addEventListener('input',()=>{count=24;updateURL();render();});
    sort.addEventListener('change',()=>{count=24;render();});
    part.addEventListener('change',()=>{syncPartSizes();count=24;updateURL();render();});
    partSize.addEventListener('change',()=>{count=24;updateURL();render();});
    root.querySelectorAll('[data-family]').forEach(b => b.addEventListener('click',()=>{family=b.dataset.family;count=24;updateURL();render();}));
    more.addEventListener('click',()=>{count+=24;render();});
    const pop = ()=>{readURL();render();}; window.addEventListener('popstate',pop);
    document.addEventListener('shopify:section:unload',function cleanup(e){if(e.target.contains(root)){window.removeEventListener('popstate',pop);document.removeEventListener('shopify:section:unload',cleanup);}});
    root.querySelector('[data-rf-pagination]').hidden = true;
    readURL();render();
    releaseLoading(root);
  }
  const mount = scope => scope.querySelectorAll('[data-rf-catalog]').forEach(root => {
    initialize(root).catch(() => {
      root.dataset.ready = '';
      releaseLoading(root);
      root.querySelector('[data-rf-results]').textContent = '一覧の読み込みに失敗しました。ページを再読み込みしてください。';
    });
  });
  mount(document); document.addEventListener('shopify:section:load', e=>mount(e.target));
})();
